import './ClaimsSummary.scss';

import { WideDivider } from '@boi/core/lib';
import { dividerColor } from '@boi/core/lib/constants/colors';
import { format } from 'date-fns';
import React from 'react';

import { TYPE_OF_CLAIM_OR_LOSS_MAPING } from '../../constants/home';

interface Props {
  claims: any[];
}

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
const ClaimsSummary = ({ claims = [] }: Props) => {
  const className = 'c-claims-summary';
  return (
    <div className="claims_section">
      {claims?.length > 0 ?
        claims.map((item, index, array) => {
          const lastIndex = array.length - 1;
          return (<>
            <table className={`${className}__table`}>
              <thead>
              <tr className={`${className}__table-row`}>
                <td className={`${className}__claim-title`}>Claim {index + 1}</td>
              </tr>
              </thead>
              <tbody key={`claim-table-body`} className={`${className}__tablebody`}>
              <tr className={`${className}__row`}>
                <th className={`${className}__cell`} scope={'row'}>Type of claim/loss</th>
                <td className={`${className}__cell__data__first`}>{TYPE_OF_CLAIM_OR_LOSS_MAPING[item.claim_type]}</td>
              </tr>
              <tr className={`${className}__row__inside`}>
                <th className={`${className}__cell`} scope={'row'}>Date of claim</th>
                <td className={`${className}__cell__data`}>{format(item.claim_date, 'DD/MM/YYYY')}</td>
              </tr>
              </tbody>
            </table>
            {index !== lastIndex && <WideDivider color={dividerColor} height={1} />}
            <br />
          </>);
        })
        :
        <table className={`${className}__table`}>
          <tr className={`${className}__row`}>
            <th className={`${className}__cell`} scope={'row'}>Type of claim/loss</th>
            <td className={`${className}__cell__data__first`}>No Claim</td>
          </tr>
          <tr className={`${className}__row__inside`}>
            <th className={`${className}__cell`} scope={'row'}>Date of claim</th>
            <td className={`${className}__cell__data`}>N/A</td>
          </tr>
        </table>
      }

    </div>

  );
};
export default ClaimsSummary;
